module.exports = __webpack_public_path__ + "static/mike-hug-9cdaaf7d3e49921758a76dac258c0fcf.png";